import Icon from "@ch/components/Icons/Icon";
import type { FC } from "react";
import { useNavigate } from "react-router-dom";

interface Props {
  onAuthenticate: () => void;
}

const ConsentRequired: FC<Props> = ({ onAuthenticate }) => {
  const navigate = useNavigate();
  return (
    <div className="w-[460px] rounded-3xl border-2 border-[#FD6E5E4D] bg-white px-8 pb-8 pt-11 shadow-sm">
      <div className="mb-3 flex items-center justify-center">
        <div className="flex h-[85px] w-[85px] items-center justify-center rounded-full bg-[#FFE9E6]">
          <Icon color="#FD6E5E" name="alert-circle" size={44} />
        </div>
      </div>

      <h2 className="mb-2 text-center text-2xl font-semibold text-ink-900">
        Consent Required
      </h2>
      <p className="mb-[60px] px-4 text-center text-sm leading-6 text-ink-600">
        Hi there! Since you&apos;re under 18, we need your parent or
        guardian&apos;s consent before you can chat with KEM
      </p>

      <button
        className="mb-[11px] w-full rounded-xl bg-[#FD6E5E] px-4 py-3 text-white transition-opacity hover:opacity-90"
        onClick={onAuthenticate}
        type="button"
      >
        Request Consent
      </button>
      <button
        className="w-full rounded-xl bg-white px-4 py-3 text-[#FD6E5E] transition-opacity hover:opacity-90"
        onClick={() => void navigate("/")}
        type="button"
      >
        Cancel
      </button>
    </div>
  );
};

export default ConsentRequired;
